<template>
  <div class="frame">
    <div class="frame-title">
      <span>
        <div>
          {{ title }}
        </div>
        <!-- 标题背景线条 -->
        <div class="frame-title-line">
        </div>
      </span>
    </div>
    <!-- 右上角图标 -->

    <div v-if="iconShow" class="frame-icon" @click="iconClick">
      <i class="iconfont icon-qiehuan"></i>
      <span>表格</span>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'frame',
  props: {
    title: String,
    iconShow: Boolean
  },
  methods: {
    iconClick() {
      this.$emit('iconClick')
    }
  }
}
</script>
<style lang = "less" >
.frame {
  border: 2px solid #f6f2f3;
  width: 90%;
  min-height: 5vh;
  margin: 0 auto;
  border-radius: 10px;
  background-color: #fff;
  padding: .1rem;
  position: relative;
  margin-top: .1rem;

  &-title {
    font-size: .18rem;
    display: inline-block;
    margin-bottom: .1rem;

    &-line {
      width: 100%;
      height: 8px;
      background-color: #f5a623;
      opacity: .5;
      margin-top: -.05rem;
    }
  }

  &-icon {
    position: absolute;
    top: .08rem;
    right: .08rem;
    font-size: .16rem;
    color: #9a9494;
  }
}
</style>